interface ProgressBarProps {
  percent?: number | null;
  raised?: number | null;
  target?: number | null;
}

export default function ProgressBar({ percent, raised, target }: ProgressBarProps) {
  if (percent == null) return null;

  const safePercent = Math.min(100, Math.max(0, percent));

  return (
    <div>
      <div
        role="progressbar"
        aria-valuenow={safePercent}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{
          background: "var(--border)",
          borderRadius: 9999,
          height: 8,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${safePercent}%`,
            height: "100%",
            background: "var(--text)",
            borderRadius: 9999,
            transition: "width 0.4s ease",
          }}
        />
      </div>
      {(raised != null || target != null) && (
        <p
          style={{
            fontSize: 11,
            color: "var(--muted)",
            marginTop: 4,
            marginBottom: 0,
          }}
        >
          {raised != null ? raised.toLocaleString("uk-UA") : "—"}{" "}
          {target != null ? `/ ${target.toLocaleString("uk-UA")} ₴` : "₴"}{" "}
          · {safePercent}%
        </p>
      )}
    </div>
  );
}
